import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React from 'react';
import '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import 'classnames';
import '../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import ToggleButtonElement from '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import 'react-i18next';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/translation/translationUtils.module.scss.js';
import '../../i18n/i18n.js';
import '../../components/Flag/Flag.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';

var ArmedStayDeviceItem = function ArmedStayDeviceItem(_ref) {
  var armedStayDevice = _ref.armedStayDevice,
    onChange = _ref.onChange,
    dataTestId = _ref.dataTestId,
    text = _ref.text,
    subText = _ref.subText,
    className = _ref.className;
  var toggle = function toggle() {
    onChange(_objectSpread2(_objectSpread2({}, armedStayDevice), {}, {
      armedHome: !armedStayDevice.armedHome
    }));
  };
  if (!armedStayDevice) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    id: dataTestId,
    className: className
  }, /*#__PURE__*/React.createElement(ToggleButtonElement, {
    onClick: toggle,
    isChecked: armedStayDevice.armedHome,
    text: text,
    subText: subText,
    dataTestId: "".concat(dataTestId, "-toggle")
  }));
};
ArmedStayDeviceItem.propTypes = {
  onChange: PropTypes.func.isRequired,
  armedStayDevice: PropTypes.shape({
    armedHome: PropTypes.bool
  }).isRequired,
  dataTestId: PropTypes.string,
  text: PropTypes.string.isRequired,
  subText: PropTypes.string,
  className: PropTypes.string
};
ArmedStayDeviceItem.defaultProps = {
  dataTestId: null,
  subText: null,
  className: ''
};

export { ArmedStayDeviceItem as default };
